// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-LeftNav-___NavItem-module__container {
  line-height: 30px;
  color: var(--colors-greyLight);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
}

.app-components-LeftNav-___NavItem-module__iconContainer {
  position: static;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 100%;
  font-size: 16px;
  width: 40px;
  height: 30px;
}

.app-components-LeftNav-___NavItem-module__menu {
  position: absolute;
  color: initial;
  font-size: 14px;
  text-transform: none;
  font-family: var(--mainFont);
  top: 0;
  left: 40px;
  z-index: 50;
  display: none;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.8);
}

.app-components-LeftNav-___NavItem-module__iconContainer:hover .app-components-LeftNav-___NavItem-module__menu {
  display: block;
}

.app-components-LeftNav-___NavItem-module__titleContainer {
  color: var(--colors-yuzu-primaryColor);
  position: relative;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  background-color: var(--colors-yuzu-blackLight);
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: solid 1px rgba(145, 153, 161, 0.45);
}

.app-components-LeftNav-___NavItem-module__subTitleContainer {
  color: var(--colors-yuzu-greyLight);
  padding-top: 8px;
  line-height: 25px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
  padding-left: 1rem;
}

.app-components-LeftNav-___NavItem-module__itemContainer:hover {
  background-color: var(--colors-yuzu-primaryColor);
  color: var(--colors-yuzu-blackLight);
}

.app-components-LeftNav-___NavItem-module__label {
  padding-left: 2rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
}
.app-components-LeftNav-___NavItem-module__haveIcon,
.app-components-LeftNav-___NavItem-module__collpased {
  padding-left: 1rem;
}

.app-components-LeftNav-___NavItem-module__subTitleContainer,
.app-components-LeftNav-___NavItem-module__itemContainer {
  background-color: var(--colors-yuzu-black);
}

.app-components-LeftNav-___NavItem-module__paper {
  padding: 0;
  margin: 0;
  border-radius: 0%;
}
`, "",{"version":3,"sources":["webpack://./app/components/LeftNav/NavItem.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,MAAM;EACN,UAAU;EACV,WAAW;EACX,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,+CAA+C;EAC/C,yBAAyB;EACzB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB","sourcesContent":[".container {\n  line-height: 30px;\n  color: var(--colors-greyLight);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  align-content: center;\n}\n\n.iconContainer {\n  position: static;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 100%;\n  font-size: 16px;\n  width: 40px;\n  height: 30px;\n}\n\n.menu {\n  position: absolute;\n  color: initial;\n  font-size: 14px;\n  text-transform: none;\n  font-family: var(--mainFont);\n  top: 0;\n  left: 40px;\n  z-index: 50;\n  display: none;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.8);\n}\n\n.iconContainer:hover .menu {\n  display: block;\n}\n\n.titleContainer {\n  color: var(--colors-yuzu-primaryColor);\n  position: relative;\n  user-select: none;\n  background-color: var(--colors-yuzu-blackLight);\n  text-transform: uppercase;\n  font-weight: bold;\n  border-bottom: solid 1px rgba(145, 153, 161, 0.45);\n}\n\n.subTitleContainer {\n  color: var(--colors-yuzu-greyLight);\n  padding-top: 8px;\n  line-height: 25px;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: bold;\n  padding-left: 1rem;\n}\n\n.itemContainer:hover {\n  background-color: var(--colors-yuzu-primaryColor);\n  color: var(--colors-yuzu-blackLight);\n}\n\n.label {\n  padding-left: 2rem;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  align-content: center;\n}\n.haveIcon,\n.collpased {\n  padding-left: 1rem;\n}\n\n.subTitleContainer,\n.itemContainer {\n  background-color: var(--colors-yuzu-black);\n}\n\n.paper {\n  padding: 0;\n  margin: 0;\n  border-radius: 0%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-LeftNav-___NavItem-module__container`,
	"iconContainer": `app-components-LeftNav-___NavItem-module__iconContainer`,
	"menu": `app-components-LeftNav-___NavItem-module__menu`,
	"titleContainer": `app-components-LeftNav-___NavItem-module__titleContainer`,
	"subTitleContainer": `app-components-LeftNav-___NavItem-module__subTitleContainer`,
	"itemContainer": `app-components-LeftNav-___NavItem-module__itemContainer`,
	"label": `app-components-LeftNav-___NavItem-module__label`,
	"haveIcon": `app-components-LeftNav-___NavItem-module__haveIcon`,
	"collpased": `app-components-LeftNav-___NavItem-module__collpased`,
	"paper": `app-components-LeftNav-___NavItem-module__paper`
};
export default ___CSS_LOADER_EXPORT___;
